import { FgBlockType } from '../../block-type.js';
import { FgType } from '../../types.js';
import { setDataValue } from '../../runtime.js';
import { sockOut } from '../../sockets.js';

const infDef = {
  type: FgBlockType.Inf,
  build: () => ({
    dataOut: [sockOut("value", FgType.Number)]
  }),
  updateOutputs(block, ctx) {
    setDataValue(ctx, block, "value", Number.POSITIVE_INFINITY);
  }
};

export { infDef };
//# sourceMappingURL=constant-inf.js.map
